import React, { Component } from 'react';
import { get } from 'lodash';
import { connect } from 'react-redux';
import { Control, Errors } from 'react-redux-form';
import classnames from 'classnames';
import Tooltip from './tooltip';
class TextField extends Component {
    // Do not allow for decimal or space in dollar value inputs
    handleKeyPress = event => {
        if (['.', ' ', '-', '+', '=', ',', 'e'].includes(event.key)) {
            event.preventDefault();
        }
    };

    render() {
        let formRowClassNames = classnames({
            form__row: true,
            'form__row--error': !this.props.valid && this.props.touched,
            'form__row--disabled': this.props.disabled
        });

        return (
            <div className={formRowClassNames}>
                {this.props.tooltip && (
                    <Tooltip
                        title={this.props.tooltip}
                        className="form-tooltip"
                    />
                )}

                <label htmlFor={this.props.model} className="form__label">
                    <span className="form__title">
                        {this.props.title}
                        {this.props.isRequired ? (
                            <span className="form__required">*</span>
                        ) : (
                            ''
                        )}
                    </span>
                    <Control.text
                        className="form__textfield"
                        model={this.props.model}
                        id={this.props.model}
                        type={this.props.type || 'text'}
                        validators={this.props.validators}
                        onChange={this.props.onChange}
                        placeholder={this.props.placeholder}
                        defaultValue={this.props.value}
                        disabled={this.props.disabled}
                        maxLength={this.props.maxLength}
                        max={this.props.max}
                        min={this.props.min}
                        onKeyPress={
                            this.props.onKeyPress ? this.handleKeyPress : null
                        }
                    />
                </label>
                <Errors
                    wrapper={props => (
                        <div className="form__error-messages">
                            {props.children}
                        </div>
                    )}
                    className="errors"
                    model={this.props.model}
                    show="touched"
                    messages={this.props.messages}
                />
            </div>
        );
    }
}

const mapStateToProps = (state, { model }) => ({
    valid: get(state.forms, `${model}.valid`, false),
    touched: get(state.forms, `${model}.touched`, false)
});

export default connect(mapStateToProps)(TextField);



// WEBPACK FOOTER //
// ./src/components/ui/text-field.js